<template>
  <transition name="fade">
    <div class="modal-wrapper strong-blur" v-if="getAuthPopupStatus">
      <div class="modal-container auth-container">

        <div class="title" v-if="!isLinkOpened">
          You have been logged out from QCRM
        </div>

        <p class="text" v-if="!isLinkOpened">
          Please, log in to QCRM in order to proceed
        </p>

        <p class="text" v-if="isLinkOpened">
          Please, make sure that you are logged in before continue
        </p>

        <div class="actions">
          <BotActionButton class="blue" @click="login()" v-if="!isLinkOpened">Login to QCRM</BotActionButton>
          <BotActionButton class="gray" @click="retryAuth()" v-if="isLinkOpened">Continue</BotActionButton>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BotActionButton from "@/components/buttons/BotActionButton"

export default {
  data: () => {
    return {
      linkOpened: false
    }
  },
  computed: {
    ...mapGetters(['getAuthPopupStatus']),
    isLinkOpened() {
      return this.linkOpened;
    }
  },
  methods: {
    ...mapActions(['getUserData']),
    async retryAuth() {
      let auth = await this.getUserData()
      if (!auth) {
        this.linkOpened = false;
      }
    },
    async login() {
      let auth = await this.getUserData();
      if (!auth) {
        this.linkOpened = true
        if (Vue.prototype.qcrm_url) {
          window.open(`${Vue.prototype.qcrm_url}/?qbotbuildersingon=true`);
        }
      }
    }
  },
  components: { BotActionButton }
}
</script>

<style lang="scss">
.auth-container {
  justify-content: space-evenly;

  .title {
    font-size: 16px;
    font-weight: 500;
    color: rgba($color: #fff, $alpha: 0.85);
  }
  .text {
    font-size: 14px;
    font-weight: 400;
  }
  .qcrm-link {
    color: rgba($color: #fff, $alpha: 0.85);
    transition: color 0.3s cubic-bezier(.25,.8,.25,1);

    &:hover {
      color: rgba($color: #fff, $alpha: 1);
    }
  }
}
</style>